module.exports = __webpack_public_path__ + "static/media/result_as_ja.411ee6fc.jpg";